import { useMemo } from 'react';
import { FlowScreen } from 'core/flow/entities';
import { ContentType, Appearance } from 'core/flow/entities/Appearance';
import { useFunnelData } from 'core/funnel/contexts';

type UseCurrentStepResult = {
  hasPrevPath: boolean;
  isHeaderHidden: boolean;
  progressBarSteps: Appearance['screensConfig']['progressBar'];
  currentStepIndex: number;
  contentType: ContentType | null;
};

const getHeaderContentType = (
  contentTypes: Record<ContentType, string[]> | undefined,
  screenId: string,
): ContentType | null => {
  for (const [type, screens] of Object.entries(contentTypes ?? {})) {
    if (screens.includes(screenId)) {
      return type as ContentType;
    }
  }
  return null;
};

export const useCurrentStep = (screenId: string): UseCurrentStepResult => {
  const config = useFunnelData();

  const memoizedResult = useMemo(() => {
    const screensConfig = config.flow.appearance?.screensConfig || {};
    const headerExcludeScreens = screensConfig?.header?.exclude;
    const contentTypes = screensConfig?.header?.contentTypes;

    const currentStep = config.flow.screens.find((screen: FlowScreen) => screen.id === screenId)
      ?.attributes[0];
    const currentStepIndex = currentStep?.index || 0;
    const isHeaderHidden = headerExcludeScreens?.includes(screenId) ?? false;
    const hasPrevPath = !!currentStep?.prev;

    return {
      hasPrevPath,
      isHeaderHidden,
      contentType: getHeaderContentType(contentTypes, screenId),
      progressBarSteps: screensConfig?.progressBar,
      currentStepIndex,
    };
  }, [config, screenId]);

  return memoizedResult;
};
